"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.authSessionCookiePrefix = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _getAppConfig = _interopRequireDefault(require("../constants/getAppConfig"));
const authSessionCookiePrefix = exports.authSessionCookiePrefix = 'icis.authSession.';

/**
 * Handles interaction with cookies that should share a lifetime with the app auth session.
 */
class AuthSessionCookieManager {
  /**
   * Gets the value of an auth session cookie.
   * @param {String} name The name of the cookie to get.
   * @return {String} The value of the requested cookie.
   */
  static get(name) {
    return _jsCookie.default.get("".concat(authSessionCookiePrefix).concat(name));
  }

  /**
   * Sets an auth session cookie with the specified name and value.
   * @param {String} name The name of the cookie to set.
   * @param {String} value The value of the cookie.
   * @return {Void} nothing is returned
   */
  static set(name, value) {
    _jsCookie.default.set("".concat(authSessionCookiePrefix).concat(name), value, {
      domain: (0, _getAppConfig.default)().urls.authDomain,
      expires: 30
    });
  }

  /**
   * Removes an auth session cookie with the specified name.
   * @param {String} name The name of the cookie to delete.
   * @return {Void} nothing is returned.
   */
  static remove(name) {
    _jsCookie.default.remove("".concat(authSessionCookiePrefix).concat(name), {
      domain: (0, _getAppConfig.default)().urls.authDomain
    });
  }

  /**
   * Removes all cookies that should be removed on logout.
   *
   * @return {Void} nothing is returned.
   */
  static removeAll() {
    const allCookies = _jsCookie.default.get();
    Object.keys(allCookies).forEach(cookieName => {
      if (cookieName.startsWith(authSessionCookiePrefix)) {
        _jsCookie.default.remove(cookieName, {
          domain: (0, _getAppConfig.default)().urls.authDomain
        });
      }
    });
  }
}
exports.default = AuthSessionCookieManager;